import { render, staticRenderFns } from "./UserStatusIcon.vue?vue&type=template&id=5bddbc20&scoped=true&"
import script from "./UserStatusIcon.vue?vue&type=script&lang=ts&"
export * from "./UserStatusIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bddbc20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
